import { makeStyles, createStyles, MuiTheme } from '@kis-technologies/kis-ui';

export const useStyles = makeStyles((theme: MuiTheme) =>
  createStyles({
    paymentOuterContainer: {
      alignItems: 'center',
      justifyContent: 'center',
      padding: '0px 24px 24px 24px',
      minWidth: '100%'
    },
    paymentInnerContainer: {
      background: 'white',
      minWidth: '100%',
      borderRadius: '8px',
      height: '809px',
      boxShadow: '0 3px 9px 0 rgba(0,0,0,0.2)',
      overflow: 'hidden',
      [theme.breakpoints.down('lg')]: {
        height: '1650px',
        flexDirection: 'column-reverse'
      },
      [theme.breakpoints.only('lg')]: {
        height: '830px'
      }
    },
    paymentImageBlock: {
      boxShadow: '0 3px 9px 0 rgba(0,0,0,0.2)',
      [theme.breakpoints.down('lg')]: {
        boxShadow: 'none',
        marginBottom: '30px'
      },
      [theme.breakpoints.only('lg')]: {
        maxWidth: '50%',
        marginBottom: '87px'
      },
      '& > * > *': {
        [theme.breakpoints.only('lg')]: {
          width: '421px',
          marginBottom: '60px'
        }
      }
    },
    paymentTextContainer: {
      display: 'flex',
      flexDirection: 'column',
      flexWrap: 'nowrap',
      padding: '120px 140px 56px 80px',
      [theme.breakpoints.only('lg')]: {
        maxWidth: '50%',
        padding: '120px 0px 56px 64px'
      }
    },
    messageHeader: {
      background: 'transparent',
      margin: '0px 0px 140px 88px',
      [theme.breakpoints.down('lg')]: {
        margin: '0px 0px 140px 30px'
      },
      [theme.breakpoints.only('lg')]: {
        margin: '0px 0px 25px 0px'
      }
    },
    totalBorderLine: {
      height: '2px',
      background: '#D8D8D8',
      color: '#2A2A2A',
      minWidth: '100%',
      [theme.breakpoints.down('lg')]: {
        marginTop: '160px',
        display: 'flex',
        alignItems: 'flex-end'
      },
      [theme.breakpoints.only('lg')]: {
        marginTop: '30px'
      }
    },
    paymentDeviceImage: {
      height: '386px',
      width: '240px'
    },
    paymentCardBlock: {
      display: 'flex',
      flexDirection: 'row',
      gap: '31px',
      alignItems: 'center',
      justifyContent: 'center'
    },
    paymentFirstDivision: {
      width: '158px',
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      height: '100px'
    },
    paymentSecondDivision: {
      width: '250px',
      height: '100px',
      display: 'flex',
      alignItems: 'center'
    }
  })
);
